<ng-container *ngIf="cart$ | async as cart">
  <div [class.online]="cart?.internalCalculation !== true" *ngIf="cart?.internalCalculation !== true">
    <div class="form-group">
      <form (ngSubmit)="applyVoucher()" [formGroup]="couponForm">
        <label class="cx-cart-coupon-title">
          {{ 'voucher.coupon' | cxTranslate }}
        </label>
  
        <div class="cx-cart-coupon-container">
          <input
            (keyup)="clearError()"
            [attr.aria-label]="'voucher.couponLabel' | cxTranslate"
            required="true"
            type="text"
            class="form-control input-coupon-code"
            formControlName="couponCode"
            placeholder="{{ 'voucher.placeholder' | cxTranslate }}"
          />
          <button
            class="btn btn-block btn-secondary apply-coupon-button"
            type="submit"
            [disabled]="cartIsLoading$ | async"
            [class.disabled]="cartIsLoading$ | async"
          >
            {{ 'voucher.apply' | cxTranslate }}
          </button>
        </div>
      </form>
    </div>
  
    <div class="coupon-error" *ngIf="error$ | async as error">
      <img class="" src="../../../../../../assets/icons/alert-circle-red.svg">
      <span class="coupon-error-text">{{ error | cxTranslate}}</span>
    </div>
  
    <cx-applied-coupons
        [vouchers]="cart.appliedVouchers"
        [cartIsLoading]="cartIsLoading$ | async"
        [isReadOnly]="false"
    >
    </cx-applied-coupons>
  </div>
</ng-container>
